import { inject, Injectable } from '@angular/core';
import { ApiResponse } from '../interfaces/api-response.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import {
  EligibilityFormTempRequest,
  EligibilityFormTempResponse,
  EligibilityQuestionnaireFieldRequest,
  EligibilityQuestionnaireFieldResponse,
} from '../interfaces/reserve-confirm-survey.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * 合適性問卷相關服務
 */
@Injectable({
  providedIn: 'root',
})
export class ReserveConfirmSurveyService {
  http: HttpClient = inject(HttpClient);

  /**
   * 查詢合適性問卷表格欄位: 確認健檢方案後點選下一步，根據已選擇的健檢項目查詢合適性問卷
   * @param request
   */
  getQuestionnaireFields(
    request: EligibilityQuestionnaireFieldRequest
  ): Observable<ApiResponse<EligibilityQuestionnaireFieldResponse>> {
    const payload: EligibilityQuestionnaireFieldRequest = request;
    return this.http.post<ApiResponse<EligibilityQuestionnaireFieldResponse>>(
      API_ENDPOINTS.ELIGIBILITY_QUESTIONNAIRE_FIELDS,
      payload
    );
  }


  /**
   * 儲存合適性問卷(暫存檔)
   * @param request
   */
  saveEligibilityFormTemp(
    request: EligibilityFormTempRequest
  ): Observable<ApiResponse<EligibilityFormTempResponse>> {
    const payload: EligibilityFormTempRequest = request;
    return this.http.post<ApiResponse<EligibilityFormTempResponse>>(
      API_ENDPOINTS.ELIGIBILITY_FORMTEMP,
      payload
    );
  }
}
